import Breadcrumb from "../components/Breadcrumb";
import WorkFLowsSuggestionEditLayer from "../components/WorkFLowsSuggestionEditLayer";

const WorkFLowsSuggestionEditPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="" />

      <WorkFLowsSuggestionEditLayer />
    </>
  );
};

export default WorkFLowsSuggestionEditPage;
